import React, { Component } from 'react'
import { Flex, Box } from 'reflexbox'
import { withRouter } from 'react-router'
import { CardContent, Input, MenuItem, Snackbar, Switch, Tooltip } from '@material-ui/core';
import { Schema } from './InputSchema'
import DynamicForm from '../DynamicForm/DynamicForm'
import set from 'set-value'
import HealtheraFooter from '../HealtheraFooter/HealtheraFooter'
import { calculateSubscriptionTotal, formatDate, formatDateFromString, getCommissionsValue, formatCurrency, getPercentageDisplayWithGlobal, convertPercentageField } from '../../helpers'
import DynamicDialog from '../DynamicDialog/DynamicDialog';
import {
  HeaderTitle,
  CardHeaderContainer,
  CardContainer,
  CardDetailsContainer,
  FieldName,
  Title,
  EditLink,
  HealtheraButton,
  EditPlanButton,
  OrganisationSettingsHeader,
  OrganisationSettingsBody,
  OrganisationSettingsInfo,
  OrganisationSettingsToggleLabel,
  RegisteredWithPlatformTextLink,
  StripeIdCopyToClipboard,
  OrganisationPaymentOverdue,
  BoldTitle,
  FloatRight,
  OrganisationSettingsToggleBlock,
  OrganisationSettingsToggleHeader,
  StripeAccountStatusPill,
  colors,
} from '../../healtheraComponents';
import payTypes from './payTypes'
import { PayOnCollectionSelect } from '../BranchDetails/components/BranchComponents'
import EmailContactsList from './EmailContactsList';
import CreateCharge from '../AccountDetails/components/CreateCharge';
import CommunicationEmail from './CommunicationEmail';
import ReviewInvitationBccEmails from './ReviewInvitationBccEmails';
import ResendTextInvites from './ResendTextInvites';
import coreAPI from '../../apis/core';

const dateFields = [
  'currentContract.startDate',
  'currentContract.contractSignedDate',
  'currentContract.endDate',
  'currentContract.paymentStartDate',
];

const currency = 'GBP';

const paymentModeLabels = {
  '': 'Organisation Stripe account',
  offline: 'Healthera Stripe account',
};

class AccountDetails extends Component {

  state = {
    accountDetails: {},
    displayPlanEditPanel: false,
    openConfirmDialog: false,
    openConfirmModal: false,
    confirmModalText: '',
    platformName: '',
    copiedToClipboardMessage:false,
    onConfirm: () => {},
    orgId: null, // Set in componentDidMount from route params
    isInvitingToStripe: false,
    pricingLaunched: null,
  };

  componentDidMount() {
    const orgID = this.props.organisationID;
    this.setState({ orgId: orgID });
    this.props.showTabIcon(false)
    this.props.getBranches(orgID)
    this.props.getWhiteLabelApps();
    this.props.getGlobalCommissionRates();
    this.props.setDisplayMenu(false);
    this.isUnmounted = false;
    this.loadPricingLaunched(orgID);
  }

  componentWillUnmount() {
    this.isUnmounted = true;
  }

  // The Healthera Pro activation link stops working once new pricing launches (HEA-2620),
  // so the email is only offered while the launch switch is known to be off. The switch is
  // global, so it doesn't need reloading when the organisation changes.
  async loadPricingLaunched(orgID) {
    let pricingLaunched = null;
    try {
      ({ pricingLaunched } = await coreAPI.getOrganisationFeatures(orgID));
    } catch (error) {
      // Left unknown, so the email stays hidden.
    }
    if (!this.isUnmounted) this.setState({ pricingLaunched });
  }

  onChange({ field, value }) {
    let { accountDetails } = this.state

    if (dateFields.includes(field)) {
      value = formatDateFromString(value)
    }

    if (['white_label_app_id', 'membership_id'].includes(field)) {
      const { whiteLabelApps } = this.props;
      const { _id: wlId } = whiteLabelApps.find(i => i.name === value) || {};
      value = wlId || null;
    }

    set(accountDetails, field, value);
    this.setState({ accountDetails })
  }

  handleEditPlan(value) {
    this.setState({ displayPlanEditPanel: value })
  }

  handleSnackBarClose() {
    this.props.resetError();
  }

  async handleSubmit() {
    const { organisation: { name = {} } = {}, branches = [] } = this.props

    const orgID = this.props.organisationID;
    let { accountDetails: { currentContract: { startDate, slots } = {} } = {} } = this.state
    if (slots < branches.length)
      return alert(`${name} currently has ${branches.length} branches. If you wish to decrease the number of slots please remove the same number of branches.`)
    if (startDate) startDate = new Date(startDate)

    const submissionData = { ...this.state.accountDetails };
    const organisationDefaultRate = submissionData?.commissions?.defaultRate;

    const appointmentValue = submissionData.commissions?.defaultRate?.appointment_commission_rate_percentage;
    if (appointmentValue && appointmentValue >= 1 && appointmentValue <= 100) {
      convertPercentageField(organisationDefaultRate, 'appointment_commission_rate_percentage', appointmentValue);
    }

    await this.props.updateOrganisation(orgID, submissionData)
    await this.props.getOrganisation(orgID)

    this.handleEditPlan(false)
  }

  openConfirmDialog(platformName) {
    this.setState({ openConfirmDialog: true, platformName });
  }

  handleConfirmDialog(platformName) {
    if (platformName === 'Stripe') this.handleInviteToRegisterWithStripe();
  }

  handleCancelDialog() {
    this.setState({ openConfirmDialog: false });
  }

  async togglePaymentOverdue(value) {
    const { _id } = this.props.organisation;
    await this.props.updateOrganisation(_id, { saas_billing: { payment_overdue: value } });
    await this.props.getOrganisation(_id);
    await this.props.getOrganisationCountsByType();
  }

  async activatePharmaciesForMobilePayment(activatePayment) {
    const { _id } = this.props.organisation;
    await this.props.activatePharmaciesForMobilePayment(_id, { activatePayment: activatePayment });
    await this.props.getOrganisation(_id);
  }

  async activatePayOnCollection(activatePayment) {
    const { _id } = this.props.organisation;
    await this.props.updateOrganisation(_id, { payment: { pay_on_collection: activatePayment } });
    await this.props.getOrganisation(_id);
  }

  async payTypeChangeHandler(event){
    const {
      organisation: { _id } = {},
    } = this.props;
    const {value} = event.target
    await this.props.updateOrganisation(_id, { payment: { pay_on_collection_in_store: value } });
    await this.props.getOrganisation(_id);
  }

  async setPaymentMode(mode) {
    const { _id } = this.props.organisation;
    await this.props.updateOrganisation(_id, { payment: { mode } });
    await this.props.getOrganisation(_id);
    this.closeConfirmModal();
  }

  onChangePaymentMode(event) {
    // Empty selection clears the setting back to standard (connected account) payments.
    const mode = event.target.value || null;
    const message = mode === 'offline'
      ? 'Payments for this organisation will be taken into Healthera\'s Stripe account instead of the organisation\'s connected account. Continue?'
      : 'Payments for this organisation will be taken into the organisation\'s connected Stripe account. Continue?';
    this.openConfirmModal(message, this.setPaymentMode.bind(this, mode));
  }

  async onChargeCommissionsManually(value) {
    const { _id } = this.props.organisation;
    await this.props.updateOrganisation(_id, { payment: { charge_commissions_manually: value } });
    await this.props.getOrganisation(_id);
    this.closeConfirmModal();
  }

  async onToggleChargeCommissionsManually(value) {
    if (value) {
      this.openConfirmModal(
        'Enabling this feature means that this organisation will not automatically be charged via Stripe for Commissions charges each month',
        this.onChargeCommissionsManually.bind(this, value),
      );
    } else {
      await this.onChargeCommissionsManually(value);
    }
  }

  async onToggleOrganisationActive(value) {
    const { _id } = this.props.organisation;
    await this.props.updateActiveStatus(_id, { active: value });
    await this.props.getOrganisation(_id);
    await this.props.getOrganisationCountsByType();
    this.closeConfirmModal();
  }

  async onToggleOrganisationActiveStatus(value) {
    if (!value) {
      return this.openConfirmModal(
        'Deactivating this organisation will set all branches as inactive',
        this.onToggleOrganisationActive.bind(this, value),
      );
    }
    await this.onToggleOrganisationActive(value);
  }

  async toggleProActivation(value) {
    const { _id } = this.props.organisation;
    await this.props.updateOrganisation(_id, {
      pro: {
        enabled: value,
        billing: value,
      },
    });
    await this.props.getOrganisation(_id);
    this.closeConfirmModal();
  }

  async requireStripeOnboarding(value) {
    const { _id } = this.props.organisation;
    await this.props.updateOrganisation(_id, { payment: { mobile_pay_required: value } });
    await this.props.getOrganisation(_id);
    this.closeConfirmModal();
  }

  async onRequireStripeOnboarding(value) {
    if (value) {
      this.openConfirmModal(
        'Enabling this feature means that all pharmacies under this organisation will be shown the mobile pay pop up on Connect until they have completed Stripe onboarding',
        this.requireStripeOnboarding.bind(this, value),
      );
    } else {
      await this.requireStripeOnboarding(value);
    }
  }

  async onToggleOrganisationBillingOption(billingOption, value) {
    const { _id } = this.props.organisation;
    await this.props.updateOrganisation(_id, { billing: { [billingOption]: value } });
    await this.props.getOrganisation(_id);
  }

  async excludeFromReserveWithGoogle(value) {
    const { _id } = this.props.organisation;
    await this.props.updateOrganisation(_id, { exclude_from_reserve_with_google: value });
    await this.props.getOrganisation(_id);
    this.closeConfirmModal();
  }

  async onToggleExcludeFromReserveWithGoogle(value) {
    const confirmationMessage = value
      ? 'Switching this ON will EXCLUDE this organisation from Reserve with Google. Their pharmacies will NOT be listed as bookable on Google. Are you sure you want to opt them out?'
      : 'Switching this OFF will INCLUDE this organisation in Reserve with Google. Their pharmacies WILL be listed as bookable on Google. Note: turning this toggle off opts them IN, it does not opt them out. Are you sure?';

    this.openConfirmModal(
      confirmationMessage,
      this.excludeFromReserveWithGoogle.bind(this, value),
    );
  }

  async handleCommunicationEmailChange(email) {
    const { _id } = this.props.organisation;
    await this.props.updateOrganisation(_id, { communication_email: email || null });
    await this.props.getOrganisation(_id);
  }

  async handleReviewInvitationBccEmailsChange(emails) {
    const { _id } = this.props.organisation;
    await this.props.updateOrganisation(_id, { review_invitation_bcc_emails: emails });
    await this.props.getOrganisation(_id);
  }

  openConfirmModal(text, onConfirm) {
    this.setState({
      openConfirmModal: true,
      confirmModalText: text,
      onConfirm,
    });
  }

  closeConfirmModal() {
    this.setState({
      openConfirmModal: false,
      confirmModalText: '',
    });
  }

  copyToClipboardHandler = () => {
    const stripeId = this.props?.organisation?.payment?.stripe_connect_id
    navigator.clipboard.writeText(stripeId);
    this.setState({copiedToClipboardMessage:true})
  }

  clipboardSuccessCloseHandler = () => {
    this.setState({ copiedToClipboardMessage:false })
  }

  async handleInviteToRegisterWithStripe() {
    const { _id, name,
      primaryUser: { email, firstName, lastName, telephone },
      commissions: {
        defaultRate: {
          transaction_fee,
          transaction_fee_percentage
        } = {} } = {} } = this.props.organisation;

    const requiredFields = {
      email,
      firstName,
      lastName,
      transaction_fee,
      transaction_fee_percentage
    };

    const missingFields = [];

    for (const [key, value] of Object.entries(requiredFields)) {
      if (!value) missingFields.push(key)
    }

    if (missingFields.length) {
      window.confirm(`Please enter the following missing fields: ${missingFields}`);
      return this.setState({ openConfirmDialog: false });
    }

    this.setState({ isInvitingToStripe: true });
    try {
      await this.props.inviteToRegisterWithStripe(_id, { email, firstName, lastName, name, telephone });
      this.setState({ openConfirmDialog: false });
      await this.props.getOrganisation(_id);
    } finally {
      this.setState({ isInvitingToStripe: false });
    }
  }

  hasChargebeeIntegration = () => {
    const { organisation } = this.props;
    return organisation && Object.keys(organisation).includes('saas_billing');
  };

  openChargebeePage = (page, Id) => window.open(`${process.env.REACT_APP_CHARGEBEE_URL}${page}/${Id}`, '_blank');

  async addEmailHandler(emailContacts = [], newEmailContact, checked) {
    const { _id } = this.props.organisation;
    let updatedEmailContacts = [];

    if (checked) {
      const emailAlreadyExists = emailContacts.find(email => email === newEmailContact);
      if (emailAlreadyExists) return alert(`${newEmailContact} has already been added`);
      updatedEmailContacts = [newEmailContact, ...emailContacts ];
    } else {
      updatedEmailContacts = emailContacts.filter(email => email !== newEmailContact);
    }

    await this.props.updateOrganisation(_id, { email_contacts: updatedEmailContacts });
    await this.props.getOrganisation(_id);
  };

  render() {
    const {
      message,
      orgID,
      whiteLabelApps,
      organisation,
      organisation: {
        primaryUser: { email },
        vat: storedVAT,
        payment: {
          stripe_connect_id: stripeID,
          date_invited: dateInvited,
          mobile_payment_activated: mobilePaymentActivated,
          charge_commissions_manually: chargeCommissionsManually,
          pay_on_collection_in_store: payOnCollectionInStore,
          mobile_pay_required: mobilePayRequired,
          mode: paymentMode,
          stripe_account_status: stripeAccountStatus,
        } = {},
        currentContract: {
          slots,
        } = {},
        commissions: {
          defaultRate: {
            transaction_fee: transaction,
            transaction_fee_percentage: transactionPercent,
            delivery,
            collect,
            otc_commission,
            minimum_charge_threshold,
            non_referred_item,
            free_items_count,
            site_cap,
            referred_appointments: referredAppointmentsFee,
            text_alerts: textAlertsFee,
            non_referred_consultation: nonReferredConsultationFee,
            referred_consultation: referredConsultationFee,
          } = {}
        } = {},
        paid_delivery: {
          delivery_cost,
          delivery_fee,
          concession_cost,
          concession_fee
        } = {},
        saas_billing: {
          id: chargebeeID,
          payment_overdue: paymentOverdue,
        } = {},
        active,
        exclude_from_reserve_with_google: excludeFromReserveWithGoogle,
        email_contacts: emailContacts,
        pro: {
          enabled = false,
          billing = false,
        } = {},
        billing: {
          text_alerts: billingForTextAlerts = false,
        } = {},
        _id: organisationId,
        subscriptions: {
          subscriptions = [],
        } = {},
        communication_email: communicationEmail,
        review_invitation_bcc_emails: reviewInvitationBccEmails,
      } = {},
      userRole,
    } = this.props;

    const isAdminUser = userRole === 'admin';
    const proEnabled = enabled && billing;
    const {
      orgId,
      openConfirmModal,
      confirmModalText,
      onConfirm,
      displayPlanEditPanel,
      openConfirmDialog,
      platformName,
      pricingLaunched,
    } = this.state;

    const {
      otc_commission: globalOtcCommission,
      delivery_service_charge,
      transaction_fee,
      transaction_fee_percentage,
      collect: globalCollectionCommission,
      delivery: globalDeliveryCommission,
      minimum_charge_threshold: globalMinimumChargeThreshold,
      non_referred_item: globalNonReferredItem,
      free_items_count: globalFreeItemsCount,
      site_cap: globalSiteCap,
      referred_appointments: globalReferredAppointmentsFee,
      text_alerts: globalTextAlertsFee,
      non_referred_consultation: globalNonReferredConsultationFee,
      referred_consultation: globalReferredConsultationFee,
      appointment_commission_rate_percentage: globalAppointmentCommissionRatePercentage,
    } = this.props.globalCommissionRates || {};

    const schema = Schema(organisation, whiteLabelApps);

    const dialogTitle = `Are you sure you want to invite ${email} to register with Stripe?`;

    const showError = Boolean(message);
    const errorMessage =
      (typeof message?.response?.data?.error === 'string' && message.response.data.error) ||
      (typeof message === 'string' && message) ||
      'An error occured';

    return (
      <>
        <Snackbar
          open={showError}
          onClose={this.handleSnackBarClose.bind(this)}
          anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
          autoHideDuration={6000}
          message={errorMessage}
        />
        <Snackbar
          open={this.state.copiedToClipboardMessage}
          onClose={this.clipboardSuccessCloseHandler}
          anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
          autoHideDuration={6000}
          message='Copied to clipboard successfully'
        />
        <DynamicDialog
          open={openConfirmDialog}
          title={dialogTitle}
          actions={
          <>
          <HealtheraButton
            onClick={this.handleConfirmDialog.bind(this, platformName)}
            margin={'0 10px 5px'}
            height={'32px'}
            width={'95px'}
            disabled={this.state.isInvitingToStripe}
          >
            {this.state.isInvitingToStripe ? 'Sending...' : 'Proceed'}
          </HealtheraButton>
          <HealtheraButton
            onClick={this.handleCancelDialog.bind(this)}
            margin={'0 10px 5px'}
            height={'32px'}
            width={'95px'}
            disabled={this.state.isInvitingToStripe}
          >
            Cancel
          </HealtheraButton>
          </>}
        />
        <DynamicDialog
          open={openConfirmModal}
          title={confirmModalText}
          actions={
            <>
              <HealtheraButton onClick={onConfirm} margin={'0 10px 5px'} height={'32px'} width={'95px'}>Proceed</HealtheraButton>
              <HealtheraButton onClick={this.closeConfirmModal.bind(this)} margin={'0 10px 5px'} height={'32px'} width={'95px'}>Cancel</HealtheraButton>
            </>
          }
        />
        <Flex p={3}>
          <Box w={4 / 12}>
            <DynamicForm
              title={'Business Address'}
              save={this.handleSubmit.bind(this)}
              editable
              displayButtons
              margintop={`5px`}
              onChange={this.onChange.bind(this)}
              fields={schema.address} />
            <DynamicForm
              title={'Organisation Notes'}
              save={this.handleSubmit.bind(this)}
              editable
              displayButtons
              margintop={`5px`}
              onChange={this.onChange.bind(this)}
              fields={schema.orgNotes}
            />
            <div>
              <OrganisationSettingsHeader>Payment Overdue</OrganisationSettingsHeader>
              <OrganisationPaymentOverdue>
                <OrganisationSettingsToggleLabel>
                  {paymentOverdue
                    ? 'The account is in arrears and has no valid payment method. Healthera Connect access is currently restricted.'
                    : `The account is not restricted from Healthera Connect from being overdue. To restrict access for an offline payment customer, please ask the finance team to upload its overdue invoices into Chargebee.`
                  }
                </OrganisationSettingsToggleLabel>
                <Tooltip
                  title={`
                  Toggle the switch off to allow temporary access.
                  It will be reinstated automatically if the customer does not input a valid payment method by the next day.
                `}
                  placement="right-start"
                >
                  <Switch
                    color="primary"
                    value={!!paymentOverdue}
                    checked={!!paymentOverdue}
                    onChange={this.togglePaymentOverdue.bind(this, !paymentOverdue)}
                  />
                </Tooltip>
              </OrganisationPaymentOverdue>
              {!!stripeID && isAdminUser && (
                <CreateCharge
                  orgId={orgId} />
              )}
            </div>
            <OrganisationSettingsToggleBlock>
              <OrganisationSettingsToggleHeader>Bill for Text Alerts</OrganisationSettingsToggleHeader>
              <Switch
                value={billingForTextAlerts}
                checked={billingForTextAlerts}
                onChange={this.onToggleOrganisationBillingOption.bind(this, 'text_alerts', !billingForTextAlerts)}
              />
            </OrganisationSettingsToggleBlock>
            <OrganisationSettingsToggleBlock>
              <OrganisationSettingsToggleHeader>Exclude from Reserve with Google</OrganisationSettingsToggleHeader>
              <Switch
                value={Boolean(excludeFromReserveWithGoogle)}
                checked={Boolean(excludeFromReserveWithGoogle)}
                onChange={this.onToggleExcludeFromReserveWithGoogle.bind(this, !excludeFromReserveWithGoogle)}
              />
            </OrganisationSettingsToggleBlock>
          </Box>
          <Box w={4 / 12}>
            <DynamicForm
              title={'Account Administrator'}
              save={this.handleSubmit.bind(this)}
              editable
              displayButtons
              margintop={`5px`}
              onChange={this.onChange.bind(this)}
              fields={schema.primaryUser} />
            <EmailContactsList
              emailContacts={emailContacts}
              onChange={this.addEmailHandler.bind(this, emailContacts)}
            />
            {isAdminUser && (<CommunicationEmail
              onChange={this.handleCommunicationEmailChange.bind(this)}
              value={communicationEmail}
            />)}
            <ReviewInvitationBccEmails
              onChange={this.handleReviewInvitationBccEmailsChange.bind(this)}
              value={reviewInvitationBccEmails}
            />
          </Box>
          <Box w={4 / 12}>
            <OrganisationSettingsHeader>Settings</OrganisationSettingsHeader>
            <OrganisationSettingsBody>
              <OrganisationSettingsInfo>
                <div>
                  <OrganisationSettingsToggleLabel>
                    Active
                  </OrganisationSettingsToggleLabel>
                  <Switch
                    value={active}
                    checked={active}
                    onChange={this.onToggleOrganisationActiveStatus.bind(this, !active)}
                  />
                </div>
                {!stripeID && (
                  <div>
                  <EditLink paddingbottom={'10px'} onClick={this.openConfirmDialog.bind(this, 'Stripe')}>
                    {dateInvited ? `Invited to join Stripe on ${formatDate(dateInvited)}` : 'Send Invite to Register with Stripe'}
                  </EditLink>
                  <OrganisationSettingsToggleLabel>
                    Require Stripe Onboarding
                  </OrganisationSettingsToggleLabel>
                  <Switch
                    value={mobilePayRequired}
                    checked={mobilePayRequired}
                    onChange={this.onRequireStripeOnboarding.bind(this, !mobilePayRequired)}
                  />
                  </div>
                )}
                {!!stripeID && (
                  <>
                    <RegisteredWithPlatformTextLink
                      href={`https://dashboard.stripe.com/connect/accounts/${stripeID}/activity`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Registered with Stripe
                    </RegisteredWithPlatformTextLink>
                    {stripeAccountStatus && (
                      <StripeAccountStatusPill
                        status={stripeAccountStatus}
                        href={`https://dashboard.stripe.com/connect/accounts/${stripeID}/activity`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {stripeAccountStatus}
                      </StripeAccountStatusPill>
                    )}
                    <StripeIdCopyToClipboard
                      onClick={this.copyToClipboardHandler}
                    >
                      {stripeID}
                    </StripeIdCopyToClipboard>
                    {isAdminUser && (
                      <div>
                        <OrganisationSettingsHeader>
                          Payment Routing
                        </OrganisationSettingsHeader>
                        <PayOnCollectionSelect
                          input={<Input />}
                          displayEmpty
                          value={paymentMode || ''}
                          onChange={this.onChangePaymentMode.bind(this)}
                          renderValue={(value) => (
                            <span style={value === 'offline' ? { color: colors.HEALTHERA_RED } : undefined}>
                              {paymentModeLabels[value] || paymentModeLabels['']}
                            </span>
                          )}
                        >
                          <MenuItem value="">{paymentModeLabels['']}</MenuItem>
                          <MenuItem value="offline">{paymentModeLabels.offline}</MenuItem>
                        </PayOnCollectionSelect>
                      </div>
                    )}
                  </>
                )}
              </OrganisationSettingsInfo>
                <Box>
                {!!stripeID && (<div>
                  <OrganisationSettingsToggleLabel>
                    {mobilePaymentActivated ? 'De-Activate' : 'Activate'} All Pharmacies for Mobile Payment
                  </OrganisationSettingsToggleLabel>
                  <Switch
                    value={!!mobilePaymentActivated}
                    checked={!!mobilePaymentActivated}
                    onChange={this.activatePharmaciesForMobilePayment.bind(this, !mobilePaymentActivated)}
                  />
                  </div>
                )}
                {!!dateInvited && (<div>
                  <OrganisationSettingsHeader>
                    Pay on Collection
                  </OrganisationSettingsHeader>
                    <PayOnCollectionSelect
                      input={<Input />}
                      value={payOnCollectionInStore}
                      onChange={this.payTypeChangeHandler.bind(this)}
                    >
                      <MenuItem value="" disabled>Not selected</MenuItem>
                      {payTypes.map(({ value, label }) => (
                        <MenuItem value={value} key={value}>{label}</MenuItem>
                      ))}
                    </PayOnCollectionSelect>
                  </div>
                )}
                {!!stripeID && (
                  <div>
                    <OrganisationSettingsToggleLabel>
                      Charge for Commissions Manually
                    </OrganisationSettingsToggleLabel>
                    <Switch
                      value={chargeCommissionsManually}
                      checked={chargeCommissionsManually}
                      onChange={this.onToggleChargeCommissionsManually.bind(this, !chargeCommissionsManually)}
                    />
                  </div>
                )}
                </Box>
              {this.hasChargebeeIntegration() && (
                <Box>
                  <EditLink float={'left'} onClick={this.openChargebeePage.bind(this, 'customers', chargebeeID)}>
                    Connected with Chargebee
                  </EditLink>
                </Box>
              )}
              {!proEnabled && pricingLaunched === false && (
                <Box>
                  <EditLink
                    onClick={() => this.props.requestProStatusActivation(organisationId)}
                  >
                    Send `Healthera Pro` activation email
                  </EditLink>
                </Box>
              )}
              <ResendTextInvites organisation={organisation} />
            </OrganisationSettingsBody>
          </Box>
        </Flex>
        <CardContainer margin={`0 0 40px 0`}>
          <CardContent>
            <CardHeaderContainer p={2}>
              <HeaderTitle fontSize={`25px`} color={`#2f9d6d`} fontWeight={`600`} padding={`0 16px 0 0`}>
                Commission rates and fees
              </HeaderTitle>
              {!displayPlanEditPanel && (
                <EditPlanButton onClick={this.handleEditPlan.bind(this, true)}>Edit</EditPlanButton>
              )}
            </CardHeaderContainer>
            {!displayPlanEditPanel && (
              <>
                <CardDetailsContainer>
                  <Box w={3 / 12}>
                    <FieldName>Number of Pharmacy Sites:</FieldName>
                    <FieldName>Commission rate - Delivery:</FieldName>
                    <FieldName>Commission rate - Collection:</FieldName>
                    <FieldName>Commission rate - Non-Referred:</FieldName>
                    <FieldName>Minimum Charge Threshold:</FieldName>
                    <FieldName>Free Items:</FieldName>
                    <FieldName>Site Cap:</FieldName>
                    <FieldName>Commission rate E-Commerce - %:</FieldName>
                    <FieldName>Delivery Charge:</FieldName>
                    <FieldName>Healthera Service Charge:</FieldName>
                    <FieldName>Concession Delivery Charge:</FieldName>
                    <FieldName>Concession Service Charge:</FieldName>
                    <FieldName>Transaction fee - fixed:</FieldName>
                    <FieldName>Transaction fee - %:</FieldName>
                    <FieldName>Referred Appointment Fee:</FieldName>
                    <FieldName>Text Alert Fee:</FieldName>
                    <FieldName>Local (Non-Referred) Consultation Fee:</FieldName>
                    <FieldName>Referred Consultation Fee:</FieldName>
                    <FieldName>Service Commission Rate - %:</FieldName>
                  </Box>
                  <Box w={4 / 12}>
                    <p>{slots}</p>
                    <p>{currency} {getCommissionsValue(globalDeliveryCommission, delivery)}</p>
                    <p>{currency} {getCommissionsValue(globalCollectionCommission, collect)}</p>
                    <p>{currency} {getCommissionsValue(globalNonReferredItem, non_referred_item)}</p>
                    <p>{currency} {getCommissionsValue(globalMinimumChargeThreshold, minimum_charge_threshold)}</p>
                    <p>{currency} {getCommissionsValue(globalFreeItemsCount, free_items_count)}</p>
                    <p>{currency} {getCommissionsValue(globalSiteCap, site_cap)}</p>
                    <p>{getCommissionsValue(globalOtcCommission, otc_commission)}%</p>
                    <p>{currency} {(delivery_cost || 0).toFixed(2)}</p>
                    <p>{currency} {(delivery_fee || delivery_service_charge || 0).toFixed(2)}</p>
                    <p>{currency} {(concession_cost || 0).toFixed(2)}</p>
                    <p>{currency} {(concession_fee || 0).toFixed(2)}</p>
                    <p>{currency} {(Number(transaction || transaction_fee || 0)).toFixed(2)}</p>
                    <p>{getCommissionsValue(transaction_fee_percentage, transactionPercent)}%</p>
                    <p>{currency} {getCommissionsValue(globalReferredAppointmentsFee, referredAppointmentsFee)}</p>
                    <p>{currency} {getCommissionsValue(globalTextAlertsFee, textAlertsFee)}</p>
                    <p>{currency} {getCommissionsValue(globalNonReferredConsultationFee, nonReferredConsultationFee)}</p>
                    <p>{currency} {getCommissionsValue(globalReferredConsultationFee, referredConsultationFee)}</p>
                    <p>{getPercentageDisplayWithGlobal(globalAppointmentCommissionRatePercentage, organisation?.commissions?.defaultRate?.appointment_commission_rate_percentage)}%</p>
                  </Box>
                  {subscriptions && (
                    <Box w={3 / 12}>
                      {subscriptions.map(({ subscription = {} }) => (
                        <>
                          <EditLink fontWeight={900} onClick={this.openChargebeePage.bind(this, 'subscriptions', subscription.id)}>
                            {subscription.subscription_items[0]?.item_price_id}
                          </EditLink>
                          <Box><BoldTitle>Subscription ID:</BoldTitle>
                            <FloatRight>{subscription.id}</FloatRight>
                          </Box>
                          <Box>
                            <BoldTitle>Status:</BoldTitle>
                            <FloatRight>{subscription.status}</FloatRight>
                          </Box>
                          {subscription.contract_term?.contract_start && (<Box><BoldTitle>Contract Start Date:</BoldTitle>
                            <FloatRight>{formatDate(subscription.contract_term.contract_start * 1000)}</FloatRight>
                          </Box>)}
                          {subscription.contract_term?.contract_end && (<Box><BoldTitle>Renewal Date:</BoldTitle>
                            <FloatRight>{formatDate(subscription.contract_term.contract_end * 1000)}</FloatRight>
                          </Box>)}
                          <Box>
                          <BoldTitle>Quantity:</BoldTitle>
                            <FloatRight>{subscription.subscription_items[0]?.quantity}</FloatRight>
                          </Box>
                          <Box><BoldTitle>Unit Price:</BoldTitle>
                            <FloatRight>{formatCurrency(subscription.subscription_items[0]?.unit_price / 100)}</FloatRight>
                          </Box>
                          {subscription.mrr > 0 && (
                            <Box><BoldTitle>Monthly Recurring Revenue:
                            </BoldTitle>
                              <FloatRight>{formatCurrency(subscription.mrr / 100)}</FloatRight>
                            </Box>
                          )}
                        </>
                      ))}
                    </Box>
                  )}
                </CardDetailsContainer>
                <Flex>
                  <Box w={7 / 12}></Box>
                  <Box w={9 / 12}></Box>
                  <Box w={5 / 12}>
                    <FieldName>Total Monthly Fees:</FieldName>
                  </Box>
                  <Box w={11 / 12}>
                    {subscriptions && <Title>{calculateSubscriptionTotal(subscriptions)}</Title>}
                  </Box>
                </Flex>
                {storedVAT && <HeaderTitle fontSize={`13px`} color={`#2f9d6d`} fontWeight={`normal`} textalign={`right`}>VAT Excluded</HeaderTitle>}
              </>
            )}
            {displayPlanEditPanel && (
              <div>
                <DynamicForm
                  title=""
                  save={this.handleSubmit.bind(this)}
                  displayButtons
                  marginTop={`5px`}
                  onChange={this.onChange.bind(this)}
                  onCancel={this.handleEditPlan.bind(this, false)}
                  fields={schema.commissionRatesAndFees}
                />
              </div>
            )}
          </CardContent>
        </CardContainer>
        {orgID && <HealtheraFooter />}
      </>
    )
  }
}

export default withRouter(AccountDetails);
